import api from './api'

export const fetchKodaInsights = () =>
	api.get('/counseling/dashboard/koda-insights')
